<template>
  <v-container>
    <v-form>
      <v-text-field label="Фамилия имя отчество" v-model="user.name" :error-messages="err['name']"/>
      <v-text-field label="Псевдоним" v-model="user.nickname"/>
      <v-select label="Дом" v-model="user.houseId" :items="houses" :error-messages="err['houseId']"/>
      <v-text-field label="Номер квартиры" v-model="user.flat" :error-messages="err['flat']"/>
      <v-switch label="Напоминать по email" v-model="user.isRemind"/>
      <slot v-for="(item, index) in user.emails">
        <v-text-field type="email" v-model="user.emails[index]" :key="index" placeholder="новый email адрес"
                      hide-details ref="emailInput" :append-icon="user.emails.length > 1 ? 'mdi-delete' : null"
                      @click:append="removeEmail(index)"/>
      </slot>
      <v-btn class="mr-4 mb-4" @click="addEmail">Добавить eMail</v-btn>
      <v-spacer class="pa-4"></v-spacer>
      <v-btn class="mr-4 mb-4" @click="saveUser">Сохранить</v-btn>
      <v-btn class="mr-4 mb-4" @click="cancelUser">Отменить</v-btn>
      <v-btn class="mr-4 mb-4" @click.stop="confirmation = true" v-if="user.id != null && user.id">Удалить</v-btn>
      <v-dialog v-model="confirmation" persistent width="290" @keydown.esc="cancelDeleteUser">
        <v-card>
          <v-toolbar dark dense flat>
            <v-icon>mdi-alert-outline</v-icon>
            <v-toolbar-title class="white--text">Удаление</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4">Вы действительно желаете удалить пользователя и все его записи?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mr-4 mb-4" @click="confirmDeleteUser">Удалить</v-btn>
            <v-btn class="mr-4 mb-4" @click="cancelDeleteUser">Отменить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "Profile",
  data() {
    return {
      user: {
        id: "",
        houseId: "",
        emails: [""],
        flat: "",
        name: "",
        nickname: "",
        isRemind: false,
      },
      confirmation: false,
      focusLastEmail: false,
      houses: [],
      validators: [],
      err: {},
    }
  },
  mounted() {
    function isEmpty(str) {
      return (str == null) || (str.trim().length < 1)
    }

    this.$http.get("/user/current").then(resp => {
          this.user = JSON.parse(JSON.stringify(resp.data))
          this.$store.commit({type: "setUser", user: resp.data})
        }
    )
    this.$http.get('/house').then(resp =>
        this.houses = resp.data.map(h => {
          return {
            text: `${h.city}, ${h.street}, ${h.number}`,
            value: h.id
          }
        })
    )
    const that = this
    let f
    // name
    f = function () {
      const e = isEmpty(that.user.name) || that.user.name.search(/.+ .+ .+/) < 0 ? "требуется фамилия имя отчество" : null
      that.$set(that.err, "name", e)
      return e == null
    }
    this.validators.push(f)
    this.$watch(function () {
      return that.user.name
    }, f)
    // houseId
    f = function () {
      const e = isEmpty(that.user.houseId) ? "обязательное значение" : null
      that.$set(that.err, "houseId", e)
      return e == null
    }
    this.validators.push(f)
    this.$watch(function () {
      return that.user.houseId
    }, f)
    // flat
    f = function () {
      const e = isEmpty(that.user.flat) ? "обязательное значение" : null
      that.$set(that.err, "flat", e)
      return e == null
    }
    this.validators.push(f)
    this.$watch(function () {
      return that.user.flat
    }, f)
  },
  methods: {
    saveUser: function () {
      const ok = this.validators.reduce((acc, cur) => {
        return cur() && acc
      }, true)
      if (ok) {
        this.$http.post("/user/", this.user).then(() => {
          this.$store.commit({type: "setUser", user: this.user})
          this.$router.push({name: "Home"})
        })
      }
    },
    cancelUser: function () {
      this.$http.get("/user/current").then(resp => {
            this.user = JSON.parse(JSON.stringify(resp.data))
            this.$store.commit({type: "setUser", user: resp.data})
          }
      )
    },
    addEmail: function () {
      this.user.emails.push("")
      this.focusLastEmail = true
    },
    removeEmail: function (index) {
      this.user.emails.splice(index, 1)
    },
    cancelDeleteUser: function () {
      this.confirmation = false
    },
    confirmDeleteUser: function () {
      this.confirmation = false
      this.$http.delete(`/user/${this.user.id}`).then(() => this.$router.push({name: 'Home'}))
    }
  }

}
</script>

<style scoped>

</style>